<template>
  <div
    class="header_area"
    :class="{ navbar_fixed: isNavbarFixed }"
    :style="isSpecialPage ? { zIndex: '9999', position: 'fixed' } : {}"
  >
    <!-- top menu -->
    <div
      v-if="!ChatMapNav"
      class="top_menu row m0"
      style="max-width: 1320px; margin: 0 auto; width: 95%"
    >
      <div class="container">
        <div class="float-left">
          <ul
            class="header_social"
            style="padding-left: 0"
          >
            <li>
              <a
                v-if="userData"
                href=""
              >
                <router-link
                  to="/profile"
                  class="nav-link"
                >{{ userData.displayName }}</router-link>
              </a>
            </li>
          </ul>
        </div>
        <div class="float-right">
          <ul class="header_social">
            <li>
              <a href="#"><i class="fa fa-facebook" /></a>
            </li>
            <li>
              <a href="#"><i class="fa fa-twitter" /></a>
            </li>
            <li>
              <a href="#"><i class="fa fa-dribbble" /></a>
            </li>
            <li>
              <a href="#"><i class="fa fa-behance" /></a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- Navbar Bottom Normal -->
    <div
      v-if="$route.path !== '/chat'"
      class="navv containerr"
    >
      <div
        id="nav-menu"
        class="nav__menu blurr"
      >
        <ul class="nav__list">
          <li class="nav__item">
            <a
              href="/ "
              class="nav__link active-link"
            >
              <i class="bx bx-home-alt nav__icon" />
              <span class="nav__name">Home</span>
            </a>
          </li>
          <li class="nav__item submenu dropup">
            <a
              class="nav__link dropdown-toggle"
              data-bs-toggle="dropdown"
              role="button"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <i class="bx bx-list-ul nav__icon" />
              <span class="nav__name">ADs</span>
            </a>
            <ul class="dropdown-menu">
              <li class="nav-item">
                <router-link
                  to="/shop"
                  class="nav-link"
                >
                  <a class="nav-link">Shop</a>
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  to="/petshome"
                  class="nav-link"
                >
                  <a class="nav-link">Pets</a>
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  to="/services"
                  class="nav-link"
                >
                  <a class="nav-link">Services</a>
                </router-link>
              </li>
            </ul>
          </li>
          <li class="nav__item">
            <router-link
              to="/add-listing"
              class="nav__link"
            >
              <i class="bx bx-list-plus nav__icon" />
              <span class="nav__name">Add Listing</span>
            </router-link>
          </li>
          <li class="nav__item">
            <router-link
              to="/chat"
              class="nav__link"
            >
              <i class="bx bx-chat nav__icon" />
              <span class="nav__name">Messages</span>
            </router-link>
          </li>
          <li class="nav__item submenu dropup">
            <a
              href=""
              class="nav__link dropdown-toggle"
              data-bs-toggle="dropdown"
              role="button"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <i class="bx bx-user nav__icon" />
              <span class="nav__name">Settings</span>
            </a>
            <ul class="dropdown-menu">
              <li class="nav-item">
                <router-link
                  to="/profile"
                  class="nav-link"
                >
                  Profile
                </router-link>
              </li>
              <li class="nav-item">
                <a
                  href=""
                  class="nav-link"
                  @click.prevent="handleLogout"
                >Logout</a>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
    <div
      v-if="$route.path === '/chat'"
      class="navv containerr"
    >
      <div
        id="nav-menu"
        class="nav__menu blurr"
      >
        <ul class="nav__list">
          <li
            class="nav__item"
            @click="toggleSidebar"
          >
            <a class="nav__link">
              <i class="bx bx-chat nav__icon" />
              <span class="nav__name">All Messages</span>
            </a>
          </li>
          <li class="nav__item">
            Chat Screen
          </li>
          <li class="nav__item">
            <router-link
              to="/"
              class="nav__link"
            >
              <i class="bx bx-home-alt nav__icon" />
              <span class="nav__name">Home</span>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
    <!-- Navbar Top  -->
    <div
      v-if="true"
      id="header_big"
      :class="ChatMapNav ? 'main_menu mapheader' : 'main_menu'"
    >
      <nav class="navbar navbar-expand-lg navbar-light main_box">
        <div class="container">
          <router-link to="/">
            <div class="navbar-brand">
              <div class="logo_h" />
            </div>
          </router-link>
          <div class="collapse navbar-collapse offset">
            <ul class="navbar-links nav navbar-nav menu_nav ml-auto">
              <li class="nav-item">
                <router-link
                  to="/"
                  class="nav-link"
                >
                  Homepage
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  to="/services"
                  class="nav-link"
                >
                  Services
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  to="/petshome"
                  class="nav-link"
                >
                  Pets
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  to="/shop"
                  class="nav-link"
                >
                  Shop
                </router-link>
              </li>
              <li
                v-if="user"
                class="nav-item"
              >
                <router-link
                  to="/add-listing"
                  class="nav-link"
                >
                  Add Listing
                </router-link>
              </li>
              <li
                v-else
                class="nav-item"
              >
                <router-link
                  to="/login"
                  class="nav-link"
                >
                  Add Listing
                </router-link>
              </li>
              <li
                v-if="user && unreadCount > 0"
                class="nav-item"
              >
                <router-link
                  to="/chat"
                  class="nav-link"
                >
                  <i
                    class="bx bx-envelope"
                    style="font-size: large"
                  />
                  <span class="badge bg-danger">{{ unreadCount }}</span>
                </router-link>
              </li>
              <li
                v-if="user"
                class="nav-item submenu dropdown"
              >
                <a
                  v-if="user.displayName"
                  class="navbar-user nav-link dropdown-toggle"
                ><i class="fa-regular fa-user" /><i
                  v-if="unreadCount > 0"
                  class="bx bx-envelope"
                  style="color: crimson"
                /></a>
                <a
                  v-else
                  class="navbar-user nav-link dropdown-toggle"
                ><i class="fa-regular fa-user" /></a>
                <ul class="navbar-dropdown dropdown-menu">
                  <li class="nav-item">
                    <router-link
                      to="/chat"
                      class="nav-link"
                    >
                      Messages
                      <span class="badge bg-danger">{{ unreadCount }} new</span>
                    </router-link>
                  </li>
                  <li class="nav-item">
                    <router-link
                      to="/profile"
                      class="nav-link"
                    >
                      Profile
                    </router-link>
                  </li>
                  <li class="nav-item">
                    <a
                      href=""
                      class="nav-link"
                      @click.prevent="handleLogout"
                    >Logout</a>
                  </li>
                </ul>
              </li>
              <li
                v-else
                class="nav-item"
              >
                <router-link
                  to="/login"
                  class="nav-link"
                >
                  Login/SignUp
                </router-link>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </div>
  </div>
</template>

<script setup>
  import { ref, onMounted, onUnmounted, computed } from 'vue'; // computed'ı buraya ekledik
  import { getAuth, onAuthStateChanged, signOut } from 'firebase/auth';
  import { useRoute } from 'vue-router'; // sadece useRoute'u import ediyoruz
  import { useUserStore } from '@/stores/userStore';
  import { storeToRefs } from 'pinia';
  import { doc, onSnapshot } from 'firebase/firestore';
  import { db } from '../firebase';
  import { useChatStore } from '@/stores/chatStore';

  import { useUnreadMessagesStore } from '@/stores/unreadMessagesStore';
  // Unread messages store
  const unreadStore = useUnreadMessagesStore();
  const { unreadCount } = storeToRefs(unreadStore);

  // import { useChatStore } from '@/stores/chatStore'
  const route = useRoute();
  const specialPages = ['/chat', '/petmapview', '/service-details', '/profile'];

  // ChatMapNav'ı computed property olarak tanımla
  const ChatMapNav = computed(() => {
    return specialPages.some((page) => route.path === page || route.path.startsWith(`${page}/`));
  });

  // Dinamik olarak belirlenen sayfalarda sabit navbar olacak
  const isSpecialPage = computed(
    () =>
      route.path.startsWith('/chat', '/petmapview', '/service-details', '/profile') ||
      specialPages.includes(route.path),
  );
  // Script setup içinde
  // const chatStore = useChatStore()

  // const router = useRouter();
  const auth = getAuth(); // Tek bir auth tanımlaması
  const userStore = useUserStore();
  const { userData } = storeToRefs(userStore);

  // Reactive references
  const user = ref(null);
  const isNavbarFixed = ref(false);
  const nav_offset_top = 100;

  let unsubscribeMessages = null; // unsubscribe ismini değiştirdik

  const chatStore = useChatStore();
  const { showSidebar, showSidebarElement } = storeToRefs(chatStore);

  const toggleSidebar = () => {
    if (showSidebar.value) {
      // Sidebar'ı kapatırken
      showSidebar.value = false;
      // Element hala görünür kalacak, animasyon bitince kaldırılacak
    } else {
      // Sidebar'ı açarken
      showSidebarElement.value = true;
      showSidebar.value = true;
    }
  };

  // Kullanıcının oturum durumunu kontrol et
  onMounted(() => {
    console.log('Component mounted');

    const unsubscribeAuth = onAuthStateChanged(auth, async (currentUser) => {
      if (currentUser) {
        user.value = currentUser;
        await userStore.fetchUserData(currentUser.uid);
        setupUnreadMessagesListener(currentUser.uid);
      } else {
        user.value = null;
        userStore.clearUserData();
        if (unsubscribeMessages) {
          unsubscribeMessages();
        }
      }
    });

    // Scroll event listener
    window.addEventListener('scroll', handleScroll);

    // Unsubscribe'i dışarı aktarıyoruz ki dışarıdan erişilebilsin
    cleanupFunctions.unsubscribeAuth = unsubscribeAuth;
  });

  // onUnmounted bloğu artık dışarıda olacak
  onUnmounted(() => {
    if (cleanupFunctions.unsubscribeAuth) {
      cleanupFunctions.unsubscribeAuth();
    }
    if (unsubscribeMessages) {
      unsubscribeMessages();
    }
    window.removeEventListener('scroll', handleScroll);
  });
  const cleanupFunctions = {
    unsubscribeAuth: null,
  };
  // Scroll event handler
  const handleScroll = () => {
    const scroll = window.scrollY;

    if (scroll >= nav_offset_top) {
      isNavbarFixed.value = true;
      adjustPaddingForPages();
    } else {
      isNavbarFixed.value = false;
      removePaddingForPages();
    }
  };

  // Sayfalara göre padding ayarla
  const adjustPaddingForPages = () => {
    if (window.location.href.indexOf('petlisting') > -1) {
      document.getElementById('adsedit_ad')?.classList.add('pad-top-50');
    }
    if (window.location.href.indexOf('profile') > -1) {
      document.getElementById('profil_preview')?.classList.add('pad-top-50');
    }
    if (window.location.href.indexOf('listing-details') > -1 && !isMobile()) {
      document.getElementById('image__box')?.classList.add('pad-top-50');
    }
  };

  // Sayfalara göre padding kaldır
  const removePaddingForPages = () => {
    if (window.location.href.indexOf('petlisting') > -1 && !isMobile()) {
      document.getElementById('adsedit_ad')?.classList.remove('pad-top-50');
    }
    if (window.location.href.indexOf('profile') > -1) {
      document.getElementById('profil_preview')?.classList.remove('pad-top-50');
    }
    if (window.location.href.indexOf('listing-details') > -1 && !isMobile()) {
      document.getElementById('image__box')?.classList.remove('pad-top-50');
    }
  };

  // Mobil cihaz kontrolü
  const isMobile = () => {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent,
    );
  };

  // Çıkış yapma işlemi
  const handleLogout = async () => {
    try {
      await signOut(auth);
      userStore.clearUserData();
    } catch (error) {
      console.error('Çıkış yaparken hata oluştu:', error);
    }
  };

  const setupUnreadMessagesListener = (userId) => {
    if (unsubscribeMessages) {
      unsubscribeMessages();
    }

    const unreadRef = doc(db, 'unread_messages', userId);
    unsubscribeMessages = onSnapshot(unreadRef, (doc) => {
      if (doc.exists()) {
        const unreadMessageIds = doc.data().unreadMessageId || [];
        unreadCount.value = unreadMessageIds.length;
      } else {
        unreadCount.value = 0;
      }
    });
  };
</script>

<style scoped>
  .navbar_fixed {
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 1000;
    background-color: white;
    /* Sabit navbar arka plan rengi */
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    /* Gölge efekti */
  }

  .pad-top-50 {
    padding-top: 50px;
  }

  .navbar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1rem;
  }

  .navbar-brand .navbar-logo {
    font-size: 1.5rem;
    font-weight: bold;
    text-decoration: none;
  }

  .navbar-menu {
    display: flex;
    align-items: center;
  }

  .navbar-links {
    display: flex;
    list-style: none;
    margin: 0;
    padding: 0;
  }

  .navbar-links li {
    margin-left: 1rem;
    position: relative;
  }

  .navbar-links a {
    text-decoration: none;
    padding: 0.5rem 1rem;
    display: block;
  }

  .navbar-links a:hover {
    background-color: rgba(255, 255, 255, 0.1);
    border-radius: 4px;
  }

  .navbar-dropdown {
    display: none;
    position: absolute;
    top: 100%;
    left: 0;
    list-style: none;
    padding: 0;
    margin: 0;
  }

  .navbar-links li:hover .navbar-dropdown {
    display: block;
  }

  .navbar-dropdown a {
    padding: 0.5rem 1rem;
    white-space: nowrap;
  }

  .navbar-dropdown a:hover {
    background-color: rgba(255, 255, 255, 0.1);
  }

  .navbar-collapse {
    flex-grow: 0;
  }

  .navbar > .container {
    padding-top: unset !important;
    margin-bottom: unset !important;
  }

  .fa {
    display: inline-block;
    font: normal normal normal 14px/1 FontAwesome;
    font-size: inherit;
    text-rendering: auto;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  @keyframes fa-spin {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }

    100% {
      -webkit-transform: rotate(359deg);
      transform: rotate(359deg);
    }
  }

  .fa-star:before {
    content: '\f005';
  }

  .fa-close:before {
    content: '\f00d';
  }

  .fa-plane:before {
    content: '\f072';
  }

  .fa-heart-o:before {
    content: '\f08a';
  }

  .fa-thumb-tack:before {
    content: '\f08d';
  }

  .fa-twitter:before {
    content: '\f099';
  }

  .fa-facebook:before {
    content: '\f09a';
  }

  .fa-github:before {
    content: '\f09b';
  }

  .fa-globe:before {
    content: '\f0ac';
  }

  .fa-caret-down:before {
    content: '\f0d7';
  }

  .fa-envelope:before {
    content: '\f0e0';
  }

  .fa-long-arrow-left:before {
    content: '\f177';
  }

  .fa-long-arrow-right:before {
    content: '\f178';
  }

  .fa-dribbble:before {
    content: '\f17d';
  }

  .fa-behance:before {
    content: '\f1b4';
  }
</style>
